<template>
    <div
        class="league"
        v-bind:class="{
            _show: isExpanded,
            JARVIS_SportPage_Btn_Collapse: isExpanded,
            JARVIS_SportPage_Btn_Expand: !isExpanded,
            _live: isLive,
            _multiple: isMixParlayMode,
        }"
    >
        <div
            v-if="isIndiaOddsDisplay"
            class="league-title"
            v-bind:class="{ _live: isLive }"
            v-on:click="toggleExpanded"
        >
            <div class="league-title-content">
                <img
                    v-if="isSportsCupIconEnabled && isSportsCupLeague"
                    class="sports-cup-zone-logo"
                    src="@/assets/images/euro-2024-icon-dark.png"
                    alt=""
                    aria-hidden="true"
                >
                <div class="league-title-text">
                    <span class="league-title-name">
                        {{ leagueName }}
                    </span>
                    <p v-if="isExpanded && leagueInformation" class="league-title-info">
                        {{ leagueInformation }}
                    </p>
                    <p v-if="isShowTwoMpSubBetInformation" class="league-title-info">
                        {{ i18n.t('mpTwoMinSubBet') }}
                    </p>
                </div>
            </div>
            <span
                v-if="!isOutright"
                class="count"
                v-bind:class="{ select: hasOddsSelect }"
            >{{ matches.length }}</span>
            <SvgIcon iconName="systemIcon_arrowBottom" />
        </div>
        <div v-else class="league-title">
            <div class="league-title-content">
                <SvgIcon v-if="isComponentInPp" v-bind:iconName="iconName" />

                <span class="league-title-name">
                    {{ leagueName }}
                </span>
                <p v-if="isExpanded && leagueInformation" class="league-title-info">
                    {{ leagueInformation }}
                </p>
                <p v-if="isShowTwoMpSubBetInformation" class="league-title-info">
                    {{ i18n.t('mpTwoMinSubBet') }}
                </p>
            </div>
            <span
                v-if="!isOutright"
                class="count"
                v-bind:class="{ select: hasOddsSelect }"
            >{{ matches.length }}</span>
        </div>
        <template v-if="isExpanded">
            <div v-if="!isOutright" class="league-oddType notranslate">
                <div>1</div>
                <div v-if="isSoccer(sportType)">
                    X
                </div>
                <div>2</div>
            </div>

            <div>
                <div v-if="isOutright" class="matchDisplay">
                    <template v-for="outright in matches">
                        <LazyLoad
                            v-if="outright.type === 'outright'"
                            v-bind:key="`${outright.id}-${outright.isLive}`"
                        >
                            <Outright v-bind:info="outright" />
                        </LazyLoad>
                    </template>
                </div>
                <div v-else class="matchDisplay">
                    <LazyLoad
                        v-for="match in matches"
                        v-bind:key="match.type === 'match' ? match.eventId : 'outright do not render this div'"
                        v-bind:placeHolderHeight="5.8"
                    >
                        <Match v-if="match.type === 'match'" v-bind:match="match" />
                    </LazyLoad>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import { defineComponent } from 'vue';
    import LazyLoad from '@/components/common/LazyLoad.vue';
    import Match from '@/indiaSite/components/match/Match.vue';
    import Outright from '@/indiaSite/components/match/marketCard/Outright.vue';
    import type { ILeagueMatchList } from '@/interface/ILeagueMatchList';
    import { useLeague } from '@/libraries/composables/useLeague';
    import { isSoccer } from '@/libraries/helpers/sportsHelper';
    import { i18n } from '@/libraries/i18n';
    import { useProductPlatformStore } from '@/stores/productPlatformStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'IndiaLeague',
        components: {
            Match,
            LazyLoad,
            Outright,
            SvgIcon,
        },
        props: {
            matches: {
                type: Array as PropType<ILeagueMatchList[]>,
                required: true,
            },
            isIndiaOddsDisplay: {
                type: Boolean,
                default: true,
            },
        },
        setup(props) {
            const {
                leagueName,
                leagueInformation,
                isOutright,
                isExpanded,
                isSportsCupLeague,
                isSportsCupIconEnabled,
                isMixParlayMode,
                hasOddsSelect,
                isShowTwoMpSubBetInformation,
                isLive,
                sportType,
                iconName,
                toggleExpanded,
            } = useLeague(props.matches);

            const { isComponentInPp } = storeToRefs(useProductPlatformStore());

            return {
                i18n,
                isLive,
                sportType,
                isSportsCupLeague,
                iconName,
                isSportsCupIconEnabled,
                isComponentInPp,
                isSoccer,
                leagueName,
                leagueInformation,
                isOutright,
                hasOddsSelect,
                isExpanded,
                isMixParlayMode,
                isShowTwoMpSubBetInformation,
                toggleExpanded,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/indiaSite/components/league";
</style>
